module.exports = VueJsonPretty;